import { render } from "./Close.vue?vue&type=template&id=5bf7e410&scoped=true"
import script from "./Close.vue?vue&type=script&lang=js"
export * from "./Close.vue?vue&type=script&lang=js"

import "./Close.vue?vue&type=style&index=0&id=5bf7e410&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf7e410"],['__file',"src/components/Close.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bf7e410"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bf7e410', __exports__)) {
    console.log('reload')
    api.reload('5bf7e410', __exports__)
  }
  
  module.hot.accept("./Close.vue?vue&type=template&id=5bf7e410&scoped=true", () => {
    console.log('re-render')
    api.rerender('5bf7e410', render)
  })

}


export default __exports__